import { create } from "zustand";

import { queryClient } from "../api/queryClient";

const initialState = {
  isLoggedIn: false,
  idToken: null,
  accessToken: null,
  refreshToken: null,
  idTokenPayload: null,
};

const useAuthStore = create((set) => ({
  ...initialState,
  setCredentials: (payload) => {
    const { accessToken, refreshToken, idToken, idTokenPayload } = payload;
    set((state) => ({
      isLoggedIn: true,
      accessToken,
      refreshToken,
      idToken,
      idTokenPayload: idTokenPayload || state.idTokenPayload,
    }));
  },
  logOut: () => {
    set({ ...initialState });
    queryClient.clear();
  },
}));

export default useAuthStore;
